// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingConfigsPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProductOfferingConfigsPageMetadataQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string, developments: Array<{ __typename?: 'Development', id: string, name: string }> }> };

export type MarketProductOfferingConfigsPageMetadataFragment = { __typename?: 'Market', id: string, name: string, developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type ProductOfferingConfigsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProductOfferingConfigsFilter>;
  order?: Types.InputMaybe<Types.ProductOfferingConfigOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ProductOfferingConfigsQuery = { __typename?: 'Query', productOfferingConfigs: { __typename?: 'ProductOfferingConfigsPage', entities: Array<{ __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], createdBy: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined }, productOffering: { __typename?: 'ProductOffering', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, isLatestActive: boolean }> } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type ProductOfferingConfigDetailFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, updatedAt: Types.Scalars['DateTime']['input'], createdAt: Types.Scalars['DateTime']['input'], createdBy: { __typename?: 'User', id: string, internalUser?: { __typename?: 'InternalUser', avatar: string, id: string, name: string } | null | undefined }, productOffering: { __typename?: 'ProductOffering', id: string, name: string, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, isLatestActive: boolean }> } };

export const MarketProductOfferingConfigsPageMetadataFragmentDoc = gql`
    fragment MarketProductOfferingConfigsPageMetadata on Market {
  ...Named
  developments {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ProductOfferingConfigDetailFragmentDoc = gql`
    fragment ProductOfferingConfigDetail on ProductOfferingConfig {
  id
  name
  updatedAt
  createdAt
  createdBy {
    id
    internalUser {
      ...Named
      avatar
    }
  }
  productOffering {
    ...Named
    development {
      ...Named
    }
    itemTemplates {
      id
      isLatestActive
    }
  }
}
    ${NamedFragmentDoc}`;
export const ProductOfferingConfigsPageMetadataDocument = gql`
    query ProductOfferingConfigsPageMetadata {
  markets {
    ...MarketProductOfferingConfigsPageMetadata
  }
}
    ${MarketProductOfferingConfigsPageMetadataFragmentDoc}`;

/**
 * __useProductOfferingConfigsPageMetadataQuery__
 *
 * To run a query within a React component, call `useProductOfferingConfigsPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingConfigsPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingConfigsPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductOfferingConfigsPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>(ProductOfferingConfigsPageMetadataDocument, options);
      }
export function useProductOfferingConfigsPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>(ProductOfferingConfigsPageMetadataDocument, options);
        }
// @ts-ignore
export function useProductOfferingConfigsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>;
export function useProductOfferingConfigsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingConfigsPageMetadataQuery | undefined, ProductOfferingConfigsPageMetadataQueryVariables>;
export function useProductOfferingConfigsPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>(ProductOfferingConfigsPageMetadataDocument, options);
        }
export type ProductOfferingConfigsPageMetadataQueryHookResult = ReturnType<typeof useProductOfferingConfigsPageMetadataQuery>;
export type ProductOfferingConfigsPageMetadataLazyQueryHookResult = ReturnType<typeof useProductOfferingConfigsPageMetadataLazyQuery>;
export type ProductOfferingConfigsPageMetadataSuspenseQueryHookResult = ReturnType<typeof useProductOfferingConfigsPageMetadataSuspenseQuery>;
export type ProductOfferingConfigsPageMetadataQueryResult = ApolloReactCommon.QueryResult<ProductOfferingConfigsPageMetadataQuery, ProductOfferingConfigsPageMetadataQueryVariables>;
export const ProductOfferingConfigsDocument = gql`
    query ProductOfferingConfigs($filter: ProductOfferingConfigsFilter, $order: ProductOfferingConfigOrder, $page: PageFilter) {
  productOfferingConfigs(filter: $filter, order: $order, page: $page) {
    entities {
      ...ProductOfferingConfigDetail
    }
    pageInfo {
      totalCount
    }
  }
}
    ${ProductOfferingConfigDetailFragmentDoc}`;

/**
 * __useProductOfferingConfigsQuery__
 *
 * To run a query within a React component, call `useProductOfferingConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingConfigsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProductOfferingConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>(ProductOfferingConfigsDocument, options);
      }
export function useProductOfferingConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>(ProductOfferingConfigsDocument, options);
        }
// @ts-ignore
export function useProductOfferingConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>;
export function useProductOfferingConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingConfigsQuery | undefined, ProductOfferingConfigsQueryVariables>;
export function useProductOfferingConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>(ProductOfferingConfigsDocument, options);
        }
export type ProductOfferingConfigsQueryHookResult = ReturnType<typeof useProductOfferingConfigsQuery>;
export type ProductOfferingConfigsLazyQueryHookResult = ReturnType<typeof useProductOfferingConfigsLazyQuery>;
export type ProductOfferingConfigsSuspenseQueryHookResult = ReturnType<typeof useProductOfferingConfigsSuspenseQuery>;
export type ProductOfferingConfigsQueryResult = ApolloReactCommon.QueryResult<ProductOfferingConfigsQuery, ProductOfferingConfigsQueryVariables>;